import { useAppSelector } from 'hooks/useAppStore';
import { selectUserGroups } from 'features/eai/selectors';
import useConfig from 'hooks/useConfig';
import { getUserGroupNamesLocale } from 'utils';

const useUserGroupNames = (userGroupNames: string[] | undefined): string => {
  const userGroups = useAppSelector(selectUserGroups);
  const { locale } = useConfig();

  return getUserGroupNamesLocale(userGroupNames, userGroups, locale);
};

export default useUserGroupNames;
